<template>
  <div>
    <slot></slot>
    <a class="btn btn-primary" @click="DataItem_AddLast"><i class="fas fa-plus-circle"></i></a>
    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th class="text-center">功能</th>
        <th>圖片 (建議圖片大小:600x400)</th>
        <th>日期</th>
        <th>說明</th>
        <th>備註</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in this.datas" :key="index">
        <td class="text-center">
          <a class="btn btn-danger" @click="DataItem_Remove(item)"><i class="fa fa-trash-alt">  </i></a>
          <a class="btn btn-primary" @click="DataItem_MoveUp(item)"><i class="fa fa-angle-up"></i>  </a>
          <a class="btn btn-primary" @click="DataItem_MoveDown(item)"><i class="fa fa-angle-down"></i>  </a>
          <a class="btn " :class="isAllowEdit? 'btn-primary' : 'btn-info'" @click="EditContent(item)"><i class="fa fa-pen"></i></a>
        </td>
        <td width="300px">
          <img :src="convertToRealUrl(item.Url)" style="width:300px;height: 200px">
          <FileUploadButton :emmit-back-param="item" v-on:uploadSuccess="uploadSuccess" ></FileUploadButton>
        </td>
        <td width="100px">
          <input type="date" class="form-control" v-model="item.Date">
        </td>
        <td >
          <input type="text" class="form-control" v-model="item.Desc">
        </td>
        <td >
          <input type="text" class="form-control" v-model="item.Memo">
        </td>
      </tr>

      </tbody>
    </table>
    <DLGContentDetailEdit ref="dlgEdit" ></DLGContentDetailEdit>

  </div>
</template>

<script>
/**

 **/

import arrayUtil from "../../../util/arrayUtil";
import util from "../../../util/util";
import DLGContentDetailEdit from "../DLGContentDetailEdit";
import FileUploadButton from "@/views/taylorAdmin/component/FileUploadButton";
import Vue from "vue";

export default {
  components: {FileUploadButton, DLGContentDetailEdit},
  //name: "imageListUpload",
  props: ["datas","isAllowEdit"],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datasDemo:[
        {
          SystemId:"",
          OrderKey:"",
          IsEnable:"",
          Date:"2021-12-01",
          Desc:"2021-22年度理事職委員名錄",
          Memo:"",
        },
        {
          SystemId:"",
          OrderKey:"",
          IsEnable:"",
          Date:"2021-12-01",
          Desc:"2021/22年度理事職委員名錄",
          Memo:"",
        },
        {
          SystemId:"",
          OrderKey:"",
          IsEnable:"",
          Date:"2021-12-01",
          Desc:"2021-22年度理事職委員名錄",
          Memo:"",
        },
      ],

    };
  },
  methods: {
    DataItem_MoveUp(item){
      arrayUtil.orderMove(false,item.SystemId,this.datas,"SystemId","OrderKey")
    },
    DataItem_MoveDown(item){
      arrayUtil.orderMove(true,item.SystemId,this.datas,"SystemId","OrderKey")
    },
    DataItem_AddLast(){
      let newItem=
          {
            SystemId:"",
            OrderKey:"",
            IsEnable:"",
            Url:"",
            Date:"",
            Desc:"",
            Memo:"",
          };
      newItem.SystemId =util.uuid();

      arrayUtil.orderAppendLast(newItem,this.datas,"OrderKey")
    },
    DataItem_Remove(item){
      arrayUtil.removeByPredicate(this.datas,s => s.SystemId===item.SystemId);
    },
    EditContent(item){
      if (this.isAllowEdit){
        this.$refs.dlgEdit.SystemId=item.SystemId;
        this.$refs.dlgEdit.ShowFiles=false;
        this.$refs.dlgEdit.ShowFile=true;
        this.$refs.dlgEdit.showModal();
      }else{
        alert("請先儲存");
      }
    },
    convertToRealUrl(url){
      return Vue.prototype.$apiAdress.replace(/\/$/, "") +url;
    },
    uploadSuccess(image,result){
      if (result && result.data.FileCount>0){
        image.Url=result.data.FileUrls[0]
      }else{
        alert("檔案上傳失敗")
      }
    },

  },
  mounted() {
  },
}
</script>

<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
  margin: 5px;
  width: 40px;
}
</style>
